<template>
  <nx-form-scope-card title="Background" icon="image" class="mt-1" collapsable>
    <v-layout row wrap>
      <v-flex xs12>
        <nx-form-color-picker
            name="backgroundColor"
            :label="$t('message.form.fields.backgroundColor')"
            :value="draft.backgroundColor"
        />
      </v-flex>
    </v-layout>
  </nx-form-scope-card>
</template>
<script>
import NxFormColorPicker from '@/modules/form/components/FormColorPicker';
import NxFormScopeCard from '@/modules/form/components/FormScopeCard';

export default {
  name: 'nx-scrollytelling-slide-background-color-scope',
  components: {
    NxFormColorPicker,
    NxFormScopeCard,
  },
  props: {
    draft: {
      type: Object,
      required: true,
    },
  },
};
</script>
